/**
 * Created by mac on 8/26/20
 */

cleverapps.UI.Tooltip = cc.Node.extend({
    ctor: function (target, options) {
        this._super();
        this.options = options;
        this.target = target;
        this.duration = options.duration || 4.0;

        this.location = options.location;

        const styles = cleverapps.styles.UI.Tooltip;

        const bg = this.bg = new cc.Scale9Sprite(bundles.tooltip.frames.tooltip_bg_png);
        this.addChild(bg);

        this.arrow = new cc.Sprite(bundles.tooltip.frames.tooltip_top_arrow_png);
        this.addChild(this.arrow);

        if (options.contentSize) {
            this.setContentSize(
                options.contentSize.width + styles.content.padding.x * 2,
                options.contentSize.height + styles.content.padding.y * 2
            );
        } else {
            this.setContentSize2(
                options.size && options.size.width || styles.SIZE.medium.width,
                options.size && options.size.height || bg.height
            );
        }

        if (options.content) {
            const content = typeof options.content === "function"
                ? options.content()
                : options.content;

            this.addContent(content);
        } else {
            this.createContent(options);
        }

        this.setVisible(false);

        if (options.control) {
            cleverapps.focusManager.registerControl(options.control, this.createListener((visible) => {
                if (visible) {
                    this.show();
                } else {
                    this.hide();
                }
            }));
        } else {
            this.show();
        }

        this.setCascadeOpacityEnabledRecursively(true);
    },

    addContent: function (content) {
        const styles = cleverapps.styles.UI.Tooltip;

        const scale = Math.min(
            this.width / (content.width * content.scaleX + 2 * styles.content.padding.x),
            this.height / (content.height * content.scaleY + 2 * styles.content.padding.y)
        );
        if (scale < 1) {
            content.setScale(content.scaleX * scale, content.scaleY * scale);
        }
        content.setAlignment(this.width / 2, this.height / 2 + styles.content.offset.y);

        this.content = content;
        this.bg.addChild(content);
    },

    createContent: function (options) {
        const styles = cleverapps.styles.UI.Tooltip;

        let text;

        if (options.text) {
            text = this.text = cleverapps.UI.generateOnlyText(options.text, cleverapps.styles.FONTS.TOOLTIP_TEXT);
        }

        let rewardsView;
        const optionsSize = options.size || cc.size();
        const size = cc.size(optionsSize.width || styles.SIZE.medium.width, optionsSize.height || this.bg.height);

        if (options.rewards) {
            rewardsView = new RewardsListComponent(options.rewards, {
                textDirection: options.textDirection,
                textPosition: options.textDirection === undefined ? styles.rewards.text : undefined,
                font: cleverapps.styles.FONTS.TOOLTIP_REWARDS_FONT,
                iconWrap: styles.rewards.iconWrap,
                noShowControls: true,
                separator: { horizontal: bundles.tooltip.frames.tooltip_plus_png },
                margin: { x: styles.rewards.margin },
                calcColumnsCount: (rewardsCount) => (rewardsCount <= 4 ? rewardsCount : Math.ceil(rewardsCount / 2))
            });

            size.width = Math.max(size.width, rewardsView.width + 2 * styles.content.padding.x);
        }

        if (text) {
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setDimensions(size.width - 2 * styles.content.padding.x, 0);
            text.fitTo(0, size.height);
        }

        const content = this.content = new cleverapps.Layout([text, rewardsView].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.rewards.margin
        });

        size.height = Math.max(size.height, content.height + 2 * styles.content.padding.y);

        this.setContentSize2(size);

        content.setAlignment(this.width / 2, this.height / 2 + styles.content.offset.y);
        this.bg.addChild(content);
    },

    hide: function () {
        this.stopAllActions();

        const duration = 0.2 * this.scale;

        this.runAction(
            new cc.Sequence(
                new cc.Spawn(
                    new cc.ScaleTo(duration, 0.3),
                    new cc.FadeOut(duration)
                ).easing(cc.easeInOut(2)),
                new cc.CallFunc(() => {
                    this.content.removeFromParent();
                }),
                new cc.RemoveSelf()
            )
        );
    },

    onAfterResize: function () {
        const box = this.target.getGlobalBoundingBox();
        const scene = cleverapps.Scenes.GetRunningScene();

        if (this.location === cleverapps.UI.Tooltip.LOCATION_BELOW && scene.convertToNodeSpace(box).y < this.height) {
            this.location = cleverapps.UI.Tooltip.LOCATION_ABOVE;
        }

        if (this.location !== cleverapps.UI.Tooltip.LOCATION_BELOW) {
            const topEdge = scene.convertToNodeSpace(cc.p(0, box.y + box.height)).y + this.arrow.height + this.height;
            if (topEdge > scene.height) {
                this.location = cleverapps.UI.Tooltip.LOCATION_BELOW;
            }
        }

        this.bg.setContentSize2(this.getContentSize());
        this.bg.setAlignment(this.width / 2, this.height / 2);

        this.updateArrow();
        if (this.location === cleverapps.UI.Tooltip.LOCATION_BELOW) {
            this.setAnchorPoint(0.5, 1);
            this.setPosition(scene.convertToNodeSpace(cc.p(box.x + box.width / 2, box.y - this.arrow.height)));
        } else {
            this.setAnchorPoint(0.5, 0);
            this.setPosition(scene.convertToNodeSpace(cc.p(box.x + box.width / 2, box.y + box.height + this.arrow.height)));
        }

        this.fitScale = Math.min(scene.width / this.width, 1);

        this.setScale(this.fitScale);

        const scaledHalfWidth = this.width * this.fitScale / 2;
        const leftEdge = this.x - scaledHalfWidth;
        const rightEdge = this.x + scaledHalfWidth;

        // bg is a child of the scaled node, so a shift in scene units has to be divided by the scale
        if (leftEdge < 0) {
            this.bg.x -= leftEdge / this.fitScale;
        } else if (rightEdge > scene.width) {
            this.bg.x -= (rightEdge - scene.width) / this.fitScale;
        }
    },

    show: function () {
        this.onAfterResize();
        this.stopAllActions();

        this.setScale(0.85, 0.8);
        this.setVisible(true);
        this.setOpacity(0);

        this.runAction(new cc.Sequence(
            new cc.Show(),
            new cc.FadeIn(0.03),
            new cc.ScaleTo(0.08, this.fitScale * 1.05, this.fitScale * 1.1),
            new cc.ScaleTo(0.06, this.fitScale)
        ).setFinalize(() => {
            this.setOpacity(255);
            this.setScale(this.fitScale);
        }));

        this.runAction(new cc.Sequence(
            new cc.DelayTime(this.duration),
            new cc.CallFunc(() => {
                this.hide();
            })
        ));
    },

    updateArrow: function () {
        const styles = cleverapps.styles.UI.Tooltip.ARROW;
        const arrowPosition = this.location === cleverapps.UI.Tooltip.LOCATION_BELOW ? styles.top : styles.bottom;
        this.arrow.setSpriteFrame(arrowPosition === styles.bottom
            ? bundles.tooltip.frames.tooltip_bottom_arrow_png
            : bundles.tooltip.frames.tooltip_top_arrow_png);

        this.arrow.setAlignment(arrowPosition);
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TOOLTIP_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    TOOLTIP_REWARDS_FONT: {
        name: "default",
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.styles.UI.Tooltip = {
    content: {
        padding: {
            x: 40,
            y: 30
        },
        offset: {
            y: 6
        }
    },

    rewards: {
        margin: 20,
        iconWrap: {
            width: 70,
            height: 70
        },
        text: {
            anchor: { x: 0, y: 0 },
            x: { align: "right", anchor: false },
            y: { align: "bottom" }
        }
    },

    SIZE: {
        short: {
            width: 360
        },
        medium: {
            width: 480
        },
        long: {
            width: 600
        }
    },

    ARROW: {
        top: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 17 }
        },
        bottom: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -16 }
        }
    }
};

cleverapps.UI.Tooltip.LOCATION_ABOVE = 0;
cleverapps.UI.Tooltip.LOCATION_BELOW = 1;
